import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ComponentsModule } from '@app/components/components.module';
import { IconsModule } from '@app/app-icons.module';
import { StylesModule } from '@app/styles/styles.module';
import { ReportViewComponent } from './report-view/report-view.component';
import { AccordionModule } from 'primeng/accordion';

@NgModule({
  declarations: [
    ReportViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    IconsModule,
    StylesModule,
    BrowserAnimationsModule,
    AccordionModule
  ]
})
export class ReportModule { }
